import { Injectable, inject } from "@angular/core";

import { CookieService } from "ngx-cookie-service";
import { BehaviorSubject } from "rxjs";
import { distinctUntilChanged, shareReplay } from "rxjs/operators";

const ConsentCookieId = "consent.retrodigital.ch";
const ConsentGivenValue = "consent-given";

@Injectable({ providedIn: "root" })
export class ConsentService {
  private readonly cookieService = inject(CookieService);

  private readonly consentSubject = new BehaviorSubject<boolean>(this.getState());

  readonly consent$ = this.consentSubject.pipe(distinctUntilChanged(), shareReplay(1));

  getState(): boolean {
    return this.cookieService.check(ConsentCookieId);
  }

  setState(given: boolean) {
    if (given) {
      this.cookieService.set(ConsentCookieId, ConsentGivenValue, new Date(2100, 1, 1), "/");
    } else {
      this.cookieService.deleteAll();
    }
    this.consentSubject.next(given);
  }
}
